import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "../Button/Button.js";
import { heightsSizeMap } from "../common/Common.js";
import { spreadSx } from "../../utils/spreadSx.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
const IconButton = forwardRef(({ size = "lg", ...props }, ref) => /* @__PURE__ */ jsx(
  Button,
  {
    "data-test-id": DATA_TEST_ID_INHERITED,
    ref,
    ...props,
    size,
    sx: [
      {
        padding: 3,
        minWidth: `${heightsSizeMap[size]}px!important`
      },
      ...spreadSx(props.sx)
    ]
  }
));
export {
  IconButton
};
//# sourceMappingURL=IconButton.js.map
